import { Users } from 'lucide-react';
import { RepTookOverChatEvent as RepTookOverChatEventType } from '../types';
import EventShell from './EventShell';

interface Props {
  event: RepTookOverChatEventType;
}

export default function RepTookOverChatEvent({ event }: Props) {
  const actor = event.payload.human_agent_name || event.payload.human_agent_email;

  return (
    <EventShell
      color="purple"
      icon={<Users className="w-3.5 h-3.5" />}
      title="Human Agent Joined"
      timestamp={event.created_at}
    >
      {actor && <p>{actor} took over the conversation</p>}
    </EventShell>
  );
}
